import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayout.vue";
import NotFound from "@/views/NotFoundPage.vue";
import DashboardLayoutUser from "../views/Layout/DashboardLayoutUser.vue";

const routes = [
    {
        path: "/",
        redirect: "Login",
        component: DashboardLayout,
        children: [
            {
                path: "/dashboard",
                name: "dashboard",
                component: () => import("../views/Dashboard.vue"),
                meta: { requiresAuth: true, requiresAdmin: true }, // Rutas para admin
            },
            {
                path: "/SimsAdd",
                name: "Asignar Org",
                component: () => import("../views/SimsAdd.vue"),
                meta: { requiresAuth: true, requiresAdmin: true },
            },
            {
                path: "/icons",
                name: "icons",
                component: () => import("../views/Icons.vue"),
                meta: { requiresAuth: true, requiresAdmin: true },
            },
            {
                path: "/Org",
                name: "Organizacion",
                component: () => import("../views/Org.vue"),
                meta: { requiresAuth: true, requiresAdmin: true },
            },
            {
                path: "/OrgAdd",
                name: "Nueva Organizacion",
                component: () => import("../views/OrgAdd.vue"),
                meta: { requiresAuth: true, requiresAdmin: true },
            },
            {
                path: "/OrgEdit/:id",
                name: "Editar Organizacion",
                component: () => import("../views/OrgEdit.vue"),
                props: true,
                meta: { requiresAuth: true, requiresAdmin: true },
            },
            {
                path: "/Plan",
                name: "Plan",
                component: () => import("../views/Plan.vue"),
                meta: { requiresAuth: true, requiresAdmin: true },
            },
            {
                path: "/PlanAdd",
                name: "Agregar Plan",
                component: () => import("../views/PlanAdd.vue"),
                meta: { requiresAuth: true, requiresAdmin: true },
            },
            {
                path: "/PlanEdit/:id",
                name: "Editar Plan",
                component: () => import("../views/PlanEdit.vue"),
                meta: { requiresAuth: true, requiresAdmin: true },
            },
            {
                path: "/User",
                name: "Usuario",
                component: () => import("../views/User.vue"),
                meta: { requiresAuth: true, requiresAdmin: true },
            },
            {
                path: "/UserAdd",
                name: "/Agregar Usuario",
                component: () => import("../views/UserAdd.vue"),
                meta: { requiresAuth: true, requiresAdmin: true },
            },
            {
                path: "/UserEdit/:id",
                name: "/Editar Usuario",
                component: () => import("../views/UserEdit.vue"),
                meta: { requiresAuth: true, requiresAdmin: true },
            },
        ],
    },
    {
        path: "/",
        redirect: "Login",
        component: DashboardLayoutUser,
        children: [
            {
                path: "/dashboardUser",
                name: "SIMS",
                component: () => import("../views/DashboardUser.vue"),
                meta: { requiresAuth: true, requiresUser: true }, // Rutas para usuarios normales
            },
        ],
    },
    {
        path: "/",
        redirect: "/login", // Usa la ruta completa para evitar confusiones
        component: AuthLayout,
        children: [
            {
                path: "/login",
                name: "login",
                component: () => import("../views/Pages/Login.vue"),
            },
            { path: "*", component: NotFound },
        ],
    },
];

export default routes;